import { extendTheme, theme as baseTheme } from '@chakra-ui/react';

import { ThemeName } from '../types/theme-name';
import { dls } from './dls';

export const getTheme = (theme: ThemeName) => {
  switch (theme) {
    case 'dls':
      return dls;
    case 'chakra':
      return extendTheme({}, {}, baseTheme);
  }
};
